var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showoff
    ? _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showoff,
            title: "设置商品上下架",
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showoff = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "top" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function ($event) {
                      return _vm.batchSet(1)
                    },
                  },
                },
                [_vm._v("批量上架")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      return _vm.batchSet(0)
                    },
                  },
                },
                [_vm._v("批量下架")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticClass: "tableBox",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                border: "",
                "header-cell-style": {
                  background: "#f5f7fa",
                },
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "40", align: "center" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "outSysCodeName",
                  label: "平台名称",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "商品上下架", align: "center" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-switch", {
                            attrs: {
                              "active-value": 1,
                              "inactive-value": 0,
                              "active-color": "#1890ff",
                              "inactive-color": "#d1d6dd",
                            },
                            on: {
                              change: (e) => {
                                _vm.switchStatus(e, scope.row)
                              },
                            },
                            model: {
                              value: scope.row.isOnSale,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "isOnSale", $$v)
                              },
                              expression: "scope.row.isOnSale",
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  900301408
                ),
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }